import { ContentGridComponent } from '../charts/content-grid-component'

export class AFCompareTopContent extends ContentGridComponent {
    static config = {
        selector: 'afCompareTopContent',
        controller: AFCompareTopContent,
        bindings: ContentGridComponent.config.bindings,
        template: ContentGridComponent.config.template,
    }

    setProperties() {

    }
}
